<template>
  <a-modal
    centered
    width="700px"
    v-model:open="isOpen"
    :closable="false"
    class="offer-modal"
  >
    <div class="flex flex-col justify-center mb-4 mt-6">
      <div class="flex flex-row items-center justify-center gap-2">
        <span class="text-3xl font-bold text-center mb-2">{{
          $t("Pos.Congratulation")
        }}</span>
      </div>
      <span class="text-2xl font-bold text-center mb-2">{{
        $t("Pos.CsEarnedFreeItem")
      }}</span>
    </div>

    <div class="receipt-modal">
      <div class="text-xl font-bold text-center mb-1">
        {{ $t("Pos.AvailableProducts") || "PRODUITS DISPONIBLES" }}
      </div>
      <div class="mb-2 bottom-border"></div>
      <div class="text-lg text-center text-gray-500 text-sm mb-3">
        {{
          $t("Pos.SelectProductToOffer") || "Sélectionnez un produit à offrir"
        }}
      </div>
      <div class="product-list overflow-y-auto max-h-72">
        <div
          v-for="item in data"
          :key="item.id"
          :class="[
            'product-row flex items-center justify-between rounded-lg mb-2 px-3 py-2 cursor-pointer transition',
            isSelected(item)
              ? 'border-2'
              : 'bg-white border border-transparent hover:bg-gray-50',
          ]"
          :style="
            isSelected(item)
              ? {
                  backgroundColor:
                    (posConfig?.store?.primaryColor || '#fc8019') + '20',
                  borderColor: posConfig?.store?.primaryColor || '#fc8019',
                }
              : {}
          "
        >
          <div class="flex items-center gap-3">
            <!-- <span class="icon bg-gray-100 rounded-sm p-2 flex items-center justify-center">
              <img :src="item.product.photo " class="w-6 h-6" />
            </span> -->
            <div>
              <div class="text-lg font-bold">
              {{ item.quantity - item.discount_quantity }} x {{ item.product.name }}
              </div>

             
            </div>
          </div>
          <div class="flex flex-col items-end">
            <div class="flex items-center gap-2 font-bold tracking-wide">
              <span class="text-lg" v-if="item.discount_quantity  && item.discount_quantity == 0 ">  {{
                formatAmount(
                  item.total,
                  currencyCode,
                  posConfig.posConfig.decimalPrecision
                )
              }}</span>
              <span v-else class="text-lg">
                {{formatAmount(
                  item.discount_quantity * item.product.full_price,
                  currencyCode,
                  posConfig.posConfig.decimalPrecision
                )}}
              </span>
              <div class="flex flex-row items-center gap-2">
                <a-button
                  class="qt-btn"
                  :disabled="item.discount_quantity >= item.quantity"
                  @click="item.discount_quantity++"
                >
                  <span class="text-lg text-center">+</span>
                </a-button>
                <span class="font-bold text-lg">{{ item.discount_quantity }}</span>
                <a-button
                  class="qt-btn"
                  :disabled="item.discount_quantity <= 0"
                  @click="item.discount_quantity--"
                >
                  <span class="text-lg text-center">-</span>
                </a-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template #footer>
      <div class="flex justify-end gap-2">
        <a-button
          size="large"
          :style="{
            color: 'white',
            backgroundColor: posConfig?.store?.primaryColor || '#fc8019',
            borderColor: posConfig?.store?.primaryColor || '#fc8019',
          }"
          :disabled="selectedItems.length === 0"
          @click="confirm"
        >
          <span class="text-lg">{{ $t("Pos.Confirm") }}</span>
        </a-button>
        <a-button key="back" size="large" @click="cancel">
          <span class="text-lg">{{ $t("Pos.Cancel") }}</span>
        </a-button>
      </div>
    </template>
  </a-modal>
</template>

<script lang="ts">
import {
  defineComponent,
  defineProps,
  defineEmits,
  onMounted,
  watch,
} from "vue";

export default defineComponent({
  name: "LbrxOfferSelectionModal",
});
</script>

<script setup lang="ts">
import { currency } from "@/_helpers";

import { ref } from "vue";
import { cartService } from "@/_services";
const props = defineProps<{
  open: boolean;
  data: any;
  posConfig: any;
  currencyCode: any;
}>();

const emit = defineEmits<{
  (e: "update:open", value: boolean): void;
  (e: "confirmOffer", value: any[]): void;
  (e: "cancelOffer"): void;
  (e: "updateCart"): void;
}>();

const isOpen = ref(props.open);

watch(
  () => props.open,
  (newValue) => {
    isOpen.value = newValue;
  }
);

watch(isOpen, (newValue) => {
  emit("update:open", newValue);
});

const closeModal = () => {
  isOpen.value = false;
};

const formatAmount = (
  amount: any,
  currencyCode: any,
  decimalPrecision: any
) => {
  const safeAmount = isNaN(amount) || amount == null ? 0 : amount;
  const safeCurrencyCode = currencyCode ?? "";
  const safeDecimalPrecision = decimalPrecision ?? 0;
  return currency.formatAmount(
    safeAmount,
    safeCurrencyCode,
    safeDecimalPrecision
  );
};

//data
const selectedItems = ref<any[]>([]);

function isSelected(item: any) {
  return item.discount_quantity > 0;
}

// Watch for changes in discount_quantity and update selectedItems accordingly
watch(() => props.data, (newData) => {
  if (newData) {
    selectedItems.value = newData.filter((item: any) => item.discount_quantity > 0);
  }
}, { deep: true, immediate: true });

const setLoyaltyCart = async () => {
  try {
    let formData = new FormData();
    const cartInfoStr = localStorage.getItem("cart_info");
    const cartId = cartInfoStr ? JSON.parse(cartInfoStr).id || "" : "";
    formData.append("cart_id", cartId);
    const selectedItemsIds = selectedItems.value
      .map((item) => item.id)
      .join(",");
    const discountQuantity = selectedItems.value.map((item) => item.discount_quantity).join(",");
    formData.append("loyalty_items_ids", selectedItemsIds);
    formData.append("discount_quantities", discountQuantity);
    const response = await cartService.setLoyaltyCart(formData);

    //console.log("response set loyalty cart", response);
    emit("updateCart");
  } catch (error) {
    console.log("error set loyalty cart", error);
  }
};

const confirm = async () => {
  if (selectedItems.value.length > 0) {
    await setLoyaltyCart();
    closeModal();
    // emit("confirmOffer", selectedItems.value);
  }
};

const cancel = () => {
  emit("cancelOffer");
};
</script>

<style scoped>
.primary-btn {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
}

.offer-modal .ant-modal-content {
  border-radius: 1.5rem;
  padding: 2rem 1.5rem;
  background: #f9fafb;
}

.receipt-container {
  background: #fff;
  border-radius: 0.75rem;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.04);
  padding: 1rem 0.5rem;
  max-width: 420px;
  margin: 0 auto;
  border: 1px dashed #e5e7eb;
}
.receipt-header {
  letter-spacing: 0.05em;
}
.receipt-row {
  margin-bottom: 0.25rem;
}

.receipt-modal {
  background: #fff;
  border-radius: 1rem;
  padding: 1rem 1rem;
  border: 2px dashed #e5e7eb;
  margin: 0 auto;
  font-family: "Exo 2", sans-serif;
}
.product-list {
  min-height: 120px;
}
.product-row {
  transition: background 0.2s, border 0.2s;
}
.checkmark {
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}
.bottom-border {
  border-bottom: 2px dashed #e5e7eb;
}
.qt-btn {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-align: center !important;
}
</style>